import { useTranslation } from 'react-i18next';
import { dirOf, resolveLocale } from '../locales';
import type { Dir, LocaleCode } from '../types';

export interface UseI18nResult {
  readonly t: ReturnType<typeof useTranslation>['t'];
  readonly locale: LocaleCode;
  readonly setLocale: (code: LocaleCode) => Promise<void>;
  readonly dir: Dir;
  readonly isRTL: boolean;
}

export function useI18n(): UseI18nResult {
  const { t, i18n } = useTranslation();
  const locale = resolveLocale(i18n.language);
  return {
    t,
    locale,
    setLocale: async (code: LocaleCode) => {
      await i18n.changeLanguage(code);
    },
    dir: dirOf(locale),
    isRTL: dirOf(locale) === 'rtl',
  };
}
